window.Products.Accessory = {

};
window.Products.Accessory.Accessory = function() {
	
};
window.Products.Accessory.Accessory.inherits(window.Products.Product);

window.Products.Accessory.Accessory.dpi = 150;